import IService from '../IService';

export default IService.extend({
  _getUrl: function () {
    return app.apiUrl('/api/v1/search/suggestions');
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  /**
   * Resolved if user is authenticated
   * @return {Promise}
   */
  get: function (data) {
    if (app.xhrExpected(this.$ajax) && this.LastSearch !== data) {
      this.$ajax.abort();
    }

    const deferred = new $.Deferred();
    this.LastSearch = data;
    this.$ajax = $.ajax({
      url: this._getUrl(),
      contentType: 'application/json',
      data: data,
      error: function (jqXHR) {
        // eslint-disable-next-line max-len
        // var response =[{"suggested":"Hill","family":"Creative","score":4.874655,"totalCount":14192,"isFresh":false},{"suggested":"Hill Range","family":"Creative","score":0.03131182,"totalCount":95,"isFresh":false},{"suggested":"Beverly Hills","family":"Editorial","score":4161.3228,"totalCount":19324,"isFresh":false},{"suggested":"Hillary Clinton","family":"Editorial","score":4.8770967,"totalCount":2442,"isFresh":false},{"suggested":"Greenacres - Beverly Hills","family":"Editorial","score":558.75836,"totalCount":488,"isFresh":false}];
        // deferred.resolve(response);

        deferred.reject(jqXHR);
      },
      /**
       * Response values:
       * true :== session is known by the server, user authenticated
       * false :== user lost authentication, was logged out
       * null :== exception
       */
      success: function (response) {
        if (response.length !== 0) {
          const normalized = _(response)
            .map((item) =>
              Object.assign(
                { text: item.suggested.toLowerCase(), source: 'server' },
                item
              )
            )
            .uniq('text')
            .value();

          deferred.resolve(normalized);
        } else {
          deferred.reject(response);
        }
      },
    }).always(() => {
      this.$ajax = null;
    });

    return Promise.resolve(deferred.promise());
  },
});
